const config = {
  version: "20251125.1",
  apiurl: "/data.json",
  successtimeout: 36000,
  gtmAnalyticsId: "GTM-PJ5XJHH",
  analyticsId: "UA-132321687-1"
};
// GTM-PJ5XJHH
export default config;
